import * as p from '@clack/prompts'
import type { AddFieldOption, GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { FORM_OPTION_FIELD_TYPE_SET } from '@cli-constants/schema.js'
import { parseInteractiveOptionsList } from './parse-interactive-options-list.js'
import { promptConfirm } from './prompt-confirm.js'
import { promptText } from './prompt-text.js'
import { validateInteractiveOptionsList } from './validate-interactive-options-list.js'

export async function promptFieldOptions(
  context: SchemaPromptContext,
  kind: GeneratedSchemaKind,
  type: string,
  creatable: boolean
): Promise<AddFieldOption[]> {
  const requiresOptions = kind === 'form' ? FORM_OPTION_FIELD_TYPE_SET.has(type) : type === 'select'

  if (!requiresOptions) {
    return []
  }

  if (kind !== 'form' && type === 'select' && creatable) {
    const staticOptions = await promptConfirm(context, 'Add static default options?', false)
    if (!staticOptions) {
      return []
    }
  }

  while (true) {
    const value = await promptText(context, 'Options list', {
      placeholder: 'Sales, Support, General',
      validate: validateInteractiveOptionsList
    })
    try {
      return parseInteractiveOptionsList(value)
    } catch (error) {
      p.log.error(error instanceof Error ? error.message : String(error))
    }
  }
}
